import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const WorkshopsList = ({ workshops, onEdit, onDelete, onManageAnnouncements }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (workshops.length === 0) {
    return (
      <div className="text-center py-12 bg-card rounded-lg border border-border">
        <Icon name="Calendar" className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
        <h3 className="text-lg font-semibold mb-2">No workshops yet</h3>
        <p className="text-muted-foreground">
          Create your first workshop to get started
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {workshops.map((workshop) => (
        <div
          key={workshop.id}
          className="bg-card rounded-lg border border-border p-6 hover:shadow-lg transition-shadow"
        >
          <div className="flex gap-6">
            {/* Image */}
            {workshop.images && workshop.images.length > 0 && (
              <div className="flex-shrink-0">
                <img
                  src={workshop.images[0]}
                  alt={workshop.title}
                  className="w-32 h-32 object-cover rounded-lg"
                />
              </div>
            )}

            {/* Content */}
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between gap-4 mb-2">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-xl font-semibold">{workshop.title}</h3>
                    {workshop.difficulty && (
                      <span className="text-xs font-semibold px-2.5 py-1 rounded-full border bg-emerald-100 text-emerald-700 border-emerald-200">
                        {workshop.difficulty}
                      </span>
                    )}
                  </div>
                  <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <Icon name="Calendar" className="w-4 h-4" />
                      {formatDate(workshop.start_date)}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name={workshop.format === 'online' ? 'Video' : 'MapPin'} className="w-4 h-4" />
                      {workshop.format === 'online' ? `Online - ${workshop.platform}` : 'Physical'}
                    </span>
                    {workshop.duration && (
                      <span className="flex items-center gap-1">
                        <Icon name="Clock" className="w-4 h-4" />
                        {workshop.duration}
                      </span>
                    )}
                  </div>
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => onEdit(workshop)}
                    className="p-2 hover:bg-muted text-foreground rounded-lg transition-colors"
                    title="Edit workshop"
                  >
                    <Icon name="Edit" className="w-5 h-5" />
                  </button>
                  <button
                    onClick={() => onDelete(workshop.id)}
                    className="p-2 hover:bg-destructive/10 text-destructive rounded-lg transition-colors"
                    title="Delete workshop"
                  >
                    <Icon name="Trash2" className="w-5 h-5" />
                  </button>
                </div>
              </div>

              <p className="text-muted-foreground line-clamp-2 mb-3">
                {workshop.description}
              </p>

              {/* Skills */}
              {workshop.skills && workshop.skills.length > 0 && (
                <div className="flex flex-wrap gap-2">
                  {workshop.skills.map((skill, index) => (
                    <span
                      key={index}
                      className="px-2 py-1 text-xs bg-primary/10 text-primary rounded-full font-medium"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              )}

              {/* Additional info */}
              {workshop.instructor && (
                <div className="mt-3 text-sm text-muted-foreground">
                  Instructor: {workshop.instructor}
                  {workshop.instructor_title && ` - ${workshop.instructor_title}`}
                </div>
              )}

              {/* Announcements button */}
              <div className="mt-4 pt-4 border-t border-border">
                <Button
                  onClick={() => onManageAnnouncements(workshop)}
                  variant="outline"
                  className="text-sm"
                >
                  <Icon name="Bell" className="w-4 h-4 mr-2" />
                  Manage Announcements
                </Button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default WorkshopsList;
